import { render, staticRenderFns } from "./HelpdeskFooter.vue?vue&type=template&id=1d7e689c&scoped=true"
import script from "./HelpdeskFooter.vue?vue&type=script&lang=ts"
export * from "./HelpdeskFooter.vue?vue&type=script&lang=ts"
import style0 from "./HelpdeskFooter.vue?vue&type=style&index=0&id=1d7e689c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e689c",
  null
  
)

export default component.exports